export default {
    methods: {
        _updateLastUpdated(time, model = this._model) {
            if (model) {
                model.updatedAt = time || moment().tz('UTC').format();
            }
        },
    },
};
